// Pharmascience — wp-login.php asset entry.
//
// Emits build/css/login.css (from the SCSS import) AND build/js/login.js.
//
// ── THIS ENTRY WAS STYLESHEET-ONLY UNTIL PHASE 2 (W-B3)
//
// Its previous comment read "There's no runtime JS for the login page — WP
// renders everything server-side", and build/js/login.js was emitted on every
// build and enqueued by nothing. Phase 2 adds the design's password-reveal
// toggle, and inc/child_login_branding.php now enqueues this bundle on
// `login_enqueue_scripts`.
//
// 🔴 wp-login.php NEVER LOADS child.js. The front-end bundle is enqueued on
// `wp_enqueue_scripts`, which does not fire on this screen, so nothing arrives
// here by inheritance. Anything the login page needs must be imported into
// THIS entry — the same trap as the dual-entry SCSS imports (W-M3).
//
// Keep this entry SMALL. It runs on the screen that authenticates people; a
// JS error must never be able to prevent a sign-in. Everything imported here
// is progressive enhancement that degrades to working core markup.

import '../scss/login.scss';
import initPasswordReveal from './modules/password-reveal';
import initLoginInlineValidate from './modules/login-inline-validate';

function boot() {
  initPasswordReveal(document);
  /* Format-only field validation. Deliberately does NOT verify credentials —
   * see the security note in the module (enumeration + lockout bypass). */
  initLoginInlineValidate(document);
}

// The bundle is enqueued deferred and in the footer, so the DOM is normally
// parsed by the time it runs; the readyState check covers the case where it
// is not, without depending on jQuery (which this screen does not load).
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
